import logger from "../utils/logger";

export async function saveProjectPeriods(uuid, pid, periods) {
    console.log("Saving project periods", { uuid, pid, periods });

    try {
        for (const period of periods) {
            await fetch(process.env.REACT_APP_API_URL + "/api/project_period", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    uuid,
                    pid,
                    index: period.index,
                    period_st_dt: period.period_st_dt,
                    period_end_dt: period.period_end_dt,
                    record_st_dt: period.record_st_dt,
                    record_end_dt: period.record_end_dt,
                }),
            });
        }
    } catch (error) {
        logger.error("saveProjectPeriods failed", { uuid, pid }, error);
    }
}

export async function getProjectPeriods(uuid, pid) {
    console.debug("Fetching project periods", { uuid, pid });

    try {
        const url = process.env.REACT_APP_API_URL + `/api/project_period?_where=(uuid,eq,${uuid})~and(pid,eq,${pid})`;
        console.log(url);
        const res = await fetch(url);
        return res.json();
    } catch (error) {
        logger.error("getProjectPeriods failed", { uuid, pid }, error);
        return [];
    }
}
